<script setup lang="ts">
import LeArticleBodyCollapsed from "./LeArticleBodyCollapsed.vue";
import LeArticleBodyExpanded from "./LeArticleBodyExpanded.vue";
import type { ClausensArticle } from "./types";

const {
  article,
  collapsible = false,
  expanded = false
} = defineProps<{
  article: ClausensArticle;
  collapsible?: boolean;
  expanded?: boolean;
}>();
</script>

<template>
  <section class="le-article-body" :class="{ 'le-article-body--compact': collapsible }">
    <div class="le-article-body__content" :class="{ 'le-article-body__content--expanded': expanded }">
      <slot name="compactExpandButton" :expanded="expanded" />
      <LeArticleBodyCollapsed
        v-if="collapsible && !expanded"
        class="le-article-body__collapsed-content"
        :article="article"
      />
      <LeArticleBodyExpanded v-else :article="article">
        <template #link="slotProps">
          <slot name="link" v-bind="slotProps" />
        </template>
      </LeArticleBodyExpanded>
    </div>
  </section>
</template>
